export default "__VITE_ASSET__ea814b68__"